import { useEffect } from 'react';
import { ToggleButtonLabelSize, YesNoToggleButton } from '@apply/components';
import { useBrokerNewReferralStore } from '../../../state/useBrokerNewReferralStore';

interface SubjectPropertyInStateProps {
    onValidationEvent: (isValid: boolean) => void;
}

export const SubjectPropertyInState: React.FC<SubjectPropertyInStateProps> = ({ onValidationEvent }) => {
    const value = useBrokerNewReferralStore((s) => s.referral.subjectPropertyInAnyStates);
    const setValue = useBrokerNewReferralStore((s) => s.set_subjectPropertyInAnyStates);

    useEffect(() => {
        if (value != undefined) {
            onValidationEvent(true);
        } else {
            onValidationEvent(false);
        }
    }, [value, onValidationEvent]);

    return (
        <div>
            <YesNoToggleButton
                id='subjectPropertyInState'
                value={value}
                onItemClick={(newValue) => setValue(newValue.itemData?.id === 'Yes')}
                label='Is the subject property in Arizona?'
                labelSize={ToggleButtonLabelSize.Medium}
                required={true}
            />
        </div>
    );
};
